import React from 'react';

type ScenarioProductProps = {
  name: string;
  brand: string;
};

const ScenarioProduct = ({ name, brand }: ScenarioProductProps) => {
  return (
    <section className='scenario-product'>
      <p>{name}</p>
      <p>{brand}</p>
    </section>
  );
};

export default ScenarioProduct;
